import Layout from '../../../components/Layout';
import { EmployeeTable } from './Table';

export default function Employee() {
  return (
    <Layout>
      <EmployeeTable />
    </Layout>
  );
}
